import { render, staticRenderFns } from "./ModalItemListAddAddition.vue?vue&type=template&id=f5c64470&"
import script from "./ModalItemListAddAddition.vue?vue&type=script&lang=js&"
export * from "./ModalItemListAddAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports